'use strict';

export default class TimeoutsController {

  /*@ngInject*/
  constructor($http, Auth, $scope, $stateParams) {
    this.Auth = Auth;
    this.$http = $http;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
  }

  fetchPatientData = () => {
    console.log('fetching single patient data..');        //for better presentation
    console.log(this.$stateParams.id);                    //for the testing purpose
    this.$http.get('/api/schedules/patientPortal/' + this.$stateParams.id)
      .then(response => {
        this.$scope.patientData = response.data;

        if(response.data.verificationState == 'pending' || response.data.verificationState == 'unverified') {
          this.$scope.verifyPageDiv = true;
          this.$scope.rejectPageDiv = false;
        }
        else if(response.data.verificationState == 'verified') {
          this.$scope.verifyPageDiv = true;
          this.$scope.rejectPageDiv = false;
        }
        else {
          this.$scope.verifyPageDiv = false;
          this.$scope.rejectPageDiv = true;
        }

        // Activate light gallery now.
        setTimeout(function(){
            $('#light-gallery').lightGallery({
                selector: '.gallery-item',
                allowMediaOverlap: false
            });
        }, 1000);


    })
      .catch(error => {
        throw error;
      });
  }

  $onInit() {
    this.fetchPatientData();
  }


}



// WEBPACK FOOTER //
// ./client/app/account/timeouts/timeouts.controller.js